import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import PublicSite from './PublicSite';
import AppHeader from './components/AppHeader';
import Login from './pages/Login';
import Videos from './pages/Videos';
import Account from './pages/Account';
import Admin from './pages/admin/Admin';
import { useAuth } from './auth/AuthContext';

function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="page">加载中…</div>;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return (
    <>
      <AppHeader />
      {children}
    </>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<PublicSite />} />
      <Route path="/login" element={<Login />} />
      <Route path="/videos" element={<RequireAuth><Videos /></RequireAuth>} />
      <Route path="/account" element={<RequireAuth><Account /></RequireAuth>} />
      <Route path="/admin" element={<RequireAuth><Admin /></RequireAuth>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
